import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { Spacer } from "components/views/atoms/Atoms"
import { useAboutYouFlowControls } from "components/views/fle/context/AboutYouFlowContext"
import { BackArrow, LeftArrow } from "components/views/fle/Molecules"
import { Progress } from "components/views/modal/Progress"
import React from "react"
import { Steps } from "../steps/journey/step-library"

export function AboutYouTopSection({ previous }): JSX.Element {
  const { goBack } = useAboutYouFlowControls()

  return (
    <>
      <Progress numSteps={3} label="About you" step={1} />
      {/* eslint-disable-next-line */}
      {/* @ts-ignore */}
      {previous && <BackArrow onClick={() => goBack(previous)} />}
      <Spacer height={3} />
    </>
  )
}

export function BackButton(): JSX.Element {
  const { gotoPreviousStep, step } = useStateMachine()
  if (step.name === Steps.WHAT_KIND_OF_JOURNEY) {
    return <BackArrow />
  }
  return <LeftArrow onClick={gotoPreviousStep} />
}

const JOURNEY_TOP_SECTION_MAP = {
  JOURNEY: {
    step: 2,
    label: "Your Journey"
  },
  MATCH: {
    step: 3,
    label: "It's a match"
  }
}

export type JourneySectionType = keyof typeof JOURNEY_TOP_SECTION_MAP

export function JourneyTopSection({ showBackButton, showProgressTracker, journeySection }): JSX.Element {
  const progressProps = JOURNEY_TOP_SECTION_MAP[journeySection]
  return (
    <>
      {showProgressTracker && <Progress numSteps={3} {...progressProps} />}
      {/* eslint-disable-next-line */}
      {/* @ts-ignore */}
      {showBackButton && <BackButton />}
      <Spacer height={3} />
    </>
  )
}
